import { useState } from "react";
import BridalEnquiries from "./BridalEnquiries";
import BridalContentEditor from "./BridalContentEditor";
import BridalGalleryAdmin from "./BridalGalleryAdmin";
import BridalAutomations from "./BridalAutomations";
import BridalCalendar from "./BridalCalendar";

const SUB = [
  { k: "enquiries", l: "Enquiries" },
  { k: "calendar", l: "Calendar" },
  { k: "content", l: "Page content & prices" },
  { k: "gallery", l: "Gallery photos" },
  { k: "automations", l: "Emails & automations" },
];

export default function BridalManager() {
  const [tab, setTab] = useState("enquiries");
  return (
    <div data-testid="admin-bridal-panel" className="space-y-6">
      <div className="flex gap-2 overflow-x-auto">
        {SUB.map((t) => (
          <button key={t.k} onClick={() => setTab(t.k)} data-testid={`bridal-subtab-${t.k}`}
            className={`shrink-0 px-4 py-2 rounded-full text-xs transition-colors duration-300 ${tab === t.k ? "bg-[#8B1B3A] text-white" : "bg-white border border-[hsl(var(--onyx)/0.1)] text-[hsl(var(--onyx)/0.7)]"}`}>
            {t.l}
          </button>
        ))}
      </div>
      {tab === "enquiries" && <BridalEnquiries />}
      {tab === "calendar" && <BridalCalendar />}
      {tab === "content" && <BridalContentEditor />}
      {tab === "gallery" && <BridalGalleryAdmin />}
      {tab === "automations" && <BridalAutomations />}
    </div>
  );
}
